import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { LayoutDashboard, Users, Building2, BookOpen, Settings, LogOut, Menu, X, ChevronLeft } from 'lucide-react';
import toast from 'react-hot-toast';

const adminLinks = [
  { to: '/admin', label: 'لوحة التحكم', icon: LayoutDashboard, exact: true },
  { to: '/admin/users', label: 'المستخدمون', icon: Users },
  { to: '/admin/listings', label: 'الإعلانات', icon: Building2 },
  { to: '/admin/bookings', label: 'الحجوزات', icon: BookOpen },
];

export default function AdminLayout() {
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    toast.success('تم تسجيل الخروج');
    navigate('/');
  };

  const isActive = (link) => {
    if (link.exact) return location.pathname === link.to;
    return location.pathname.startsWith(link.to);
  };

  return (
    <div className="min-h-screen bg-dark-900 flex" dir="rtl">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-16'} bg-dark-800 border-l border-dark-700 transition-all duration-300 flex flex-col`}>
        <div className="p-4 border-b border-dark-700 flex items-center justify-between">
          {sidebarOpen && <span className="text-xl font-bold gradient-text">SPORTIX ADMIN</span>}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-1.5 rounded-lg hover:bg-dark-700 text-dark-400 hover:text-white transition-colors">
            {sidebarOpen ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {adminLinks.map(({ to, label, icon: Icon, exact }) => (
            <Link key={to} to={to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors ${
                isActive({ to, exact })
                  ? 'bg-primary-600 text-white'
                  : 'text-dark-300 hover:bg-dark-700 hover:text-white'
              }`}>
              <Icon size={18} />
              {sidebarOpen && <span className="text-sm font-medium">{label}</span>}
            </Link>
          ))}
        </nav>

        <div className="p-3 border-t border-dark-700">
          <Link to="/" className={`flex items-center gap-3 px-3 py-2 rounded-xl text-dark-400 hover:text-white hover:bg-dark-700 transition-colors text-sm ${!sidebarOpen && 'justify-center'}`}>
            <ChevronLeft size={16} />
            {sidebarOpen && 'العودة للموقع'}
          </Link>
          <button onClick={handleLogout}
            className={`w-full flex items-center gap-3 px-3 py-2 rounded-xl text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors text-sm ${!sidebarOpen && 'justify-center'}`}>
            <LogOut size={16} />
            {sidebarOpen && 'تسجيل الخروج'}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
